import { Link } from "@tanstack/react-router";

import { DateBlock } from "@/components/site/DateBlock";
import { LazyEventCardActions } from "@/components/site/LazyEventCardActions";
import { useMemberRoles } from "@/integrations/fc/auth0";
import type { Meeting } from "@/lib/content";
import { meetingDateParts, meetingLocationLabel } from "@/lib/meeting-format";

export function MeetingCard({ meeting }: { meeting: Meeting }) {
  const { isAdmin } = useMemberRoles();
  const isUpcoming = meeting.is_upcoming;
  const parts = meetingDateParts(meeting);
  const location = meetingLocationLabel(meeting);
  // Ohne Textauszug bleibt in der Kachel Platz fuer eine Titelzeile mehr.
  const titleClamp = meeting.excerpt || isAdmin ? "line-clamp-2" : "line-clamp-3";

  return (
    <div className="relative">
    <Link
      to="/meetings/$slug"
      params={{ slug: meeting.slug }}
      className={`group flex h-[265px] flex-col overflow-hidden border-2 border-dashed border-card-border bg-card p-6 transition-colors hover:border-accent ${isAdmin ? "pb-16" : ""}`}
    >
      <div className="flex items-start justify-between gap-3">
        <span
          className={`fc-eyebrow inline-block px-3 py-1.5 text-center text-primary-foreground ${
            isUpcoming ? "bg-accent" : "bg-primary"
          }`}
        >
          {meeting.category}
        </span>
        {parts && <DateBlock parts={parts} tone={isUpcoming ? "accent" : "dark"} />}
      </div>

      {location && <p className="fc-meta mt-6 line-clamp-1 text-accent">{location}</p>}

      <h3
        className={`fc-h4 ${location ? "mt-2" : "mt-6"} ${titleClamp} text-foreground group-hover:text-accent`}
      >
        {meeting.title}
      </h3>

      {meeting.excerpt && (
        <p className="mt-3 line-clamp-2 fc-body text-muted-foreground">{meeting.excerpt}</p>
      )}
    </Link>
    <LazyEventCardActions slug={meeting.slug} title={meeting.title} />
    </div>
  );
}
